export default __webpack_public_path__ + "static/media/welcome_img.32f2f6d9.svg";